// removed by extract-text-webpack-plugin
module.exports = {"FormInner":"FormNumber__FormInner___1BnuJ","Title":"FormNumber__Title___2uy7n","Input":"FormNumber__Input___OcGUS","InputError":"FormNumber__InputError___3HMim","Wrapper":"FormNumber__Wrapper___1A-Ea","Loader":"FormNumber__Loader___3I8V4","loader10":"FormNumber__loader10___1b3ga","SubmitButton":"FormNumber__SubmitButton___2Mvrv","BlueButton":"FormNumber__BlueButton___1E4sc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/FormNumber/FormNumber.scss
// module id = 1438
// module chunks = 0